import React from 'react'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {useLocation} from 'react-router'
import {checkIsActive, isAccountingAsideItemActive, KTSVG} from '../../../helpers'
import {useLayout} from '../../core'

type Props = {
  to: string
  title: string
  icon?: string
  fontIcon?: string
  hasBullet?: boolean
  hasArrow?: boolean
  exact?: boolean
  iconClassName?: string
  children?: React.ReactNode
}

const AsideMenuItem: React.FC<Props> = ({
  children,
  to,
  title,
  icon,
  fontIcon,
  hasBullet = false,
  hasArrow = false,
  exact = false,
  iconClassName,
}) => {
  const {pathname} = useLocation()
  const isAccountingLeaf = to === '/accounting' || to.startsWith('/accounting/')
  const isActive = exact
    ? pathname.split(/[?#]/)[0] === to
    : isAccountingLeaf
      ? isAccountingAsideItemActive(pathname, to)
      : checkIsActive(pathname, to)
  const {config} = useLayout()
  const {aside} = config

  return (
    <div className='menu-item'>
      <Link className={clsx('menu-link without-sub', {active: isActive})} to={to} title={title}>
        {hasBullet && (
          <span className='menu-bullet'>
            <span className='bullet bullet-dot'></span>
          </span>
        )}
        {icon && aside.menuIcon === 'svg' && (
          <span className='menu-icon'>
            <KTSVG path={icon} className={clsx('svg-icon-2', iconClassName)} />
          </span>
        )}
        {fontIcon && aside.menuIcon === 'font' && <i className={clsx('bi fs-3', fontIcon)}></i>}
        <span className='menu-title'>{title}</span>
        {hasArrow ? <span className='menu-arrow'></span> : null}
      </Link>
      {children}
    </div>
  )
}

export {AsideMenuItem}
